import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Observable, map } from 'rxjs';

import { asPaxTypeKey } from '@fcom/dapi/utils';
import { FinnairFrequentFlyerCardItem, FinnairPassengerCode, FinnairPassengerItem } from '@fcom/dapi/api/models';
import { getAirlineNameByCode } from '@fcom/utils';
import { ButtonTheme, IconPosition } from '@fcom/ui-components';

@Component({
  selector: 'fin-passenger-info-renewed',
  templateUrl: './passenger-info-renewed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PassengerInfoRenewedComponent implements OnInit {
  readonly FinnairPassengerCode = FinnairPassengerCode;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;

  @Input()
  passenger$: Observable<FinnairPassengerItem>;

  @Input()
  showEdit = false;

  @Output()
  edit: EventEmitter<void> = new EventEmitter();

  extendedPassenger$: Observable<
    FinnairPassengerItem & {
      paxTypeKey: string;
      cards: (FinnairFrequentFlyerCardItem & { airlineName: string })[];
    }
  >;

  ngOnInit(): void {
    this.extendedPassenger$ = this.passenger$.pipe(
      map((passenger) => ({
        ...passenger,
        paxTypeKey: asPaxTypeKey(passenger.passengerTypeCode).toLowerCase(),
        passengerTypeCode: passenger.passengerTypeCode,
        cards: (passenger.frequentFlyerCards ?? []).map((card) => ({
          ...card,
          airlineName: getAirlineNameByCode(card?.companyCode),
        })),
      }))
    );
  }
}
